// Waarom een ISS-cel (nog) niet gepubliceerd kan worden. Eén regel voor de
// agenda (buildAgendaRows) en het celdetail (CellDetail), gelijk aan het slot op
// de server (functions/intelligence/saveQuestionInsight.js, ADR-057): P2 gehaald
// én een toonbare classificatie. Twee kopieën liepen anders vroeg of laat uiteen.
//
// Valt dicht: geen cel, geen P2-uitkomst of geen classificatie blokkeert.
// AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading

import { ISS_EXTERNAL_CLASSIFICATIONS } from '../sectorInsights/issClassifications'

/**
 * @param {{classification?: string, gates?: {p2?: {passed?: boolean}}}|null} cell - ISS-celdocument
 * @returns {('p2'|'classificatie'|null)} de blokkerende poort, of null als publiceren kan
 */
const cellPublishBlocker = (cell) => {
    if (!cell || !(cell.gates && cell.gates.p2 && cell.gates.p2.passed === true)) return 'p2'
    if (!ISS_EXTERNAL_CLASSIFICATIONS.includes(cell.classification)) return 'classificatie'
    return null
}

export default cellPublishBlocker
